import { t } from '@/utils/i18n'
import styles from './ProductNotFound.module.less'
import { useNavigate } from 'react-router-dom'
import { useCorpInfoStore } from '@/stores'
import productNotFoundSvg from '@/assets/img/product_not_found.svg'

function ProductNotFound() {
  const navigate = useNavigate()
  const { corpInfo } = useCorpInfoStore()
  const { corpId } = corpInfo

  // 回到分类页
  async function handleEnterStore() {
    navigate(`/album/${corpId}`)
  }

  return (
    <div className={styles['product-not-found']}>
      <div className={styles['bd']}>
        <img className={styles['product-img']} src={productNotFoundSvg} />
        <p className={styles['grey']}>{t('商品找不到了…')}</p>
        <div className={styles['button-block']}>
          <button className={styles['enter-store']} onClick={handleEnterStore}>
            {t('查看新品')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductNotFound
